import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const projectInvestigatorsApi = {
    getProjectInvestigatorById: (id: number): Observable<Dtos.GetProjectInvestigatorByIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectInvestigatorById = new Dtos.GetProjectInvestigatorById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetProjectInvestigatorByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getProjectInvestigatorsByProjectId: (projectId: number): Observable<Dtos.GetProjectInvestigatorsByProjectIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectInvestigatorsByProjectId = new Dtos.GetProjectInvestigatorsByProjectId();

        request.projectId = projectId;

        //Send request.
        const response: Promise<Dtos.GetProjectInvestigatorsByProjectIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    createProjectInvestigator: (personnelId: number, trialId: number): Observable<Dtos.CreateProjectInvestigatorResponse> => {
        //Create the request.
        let request: Dtos.CreateProjectInvestigator = new Dtos.CreateProjectInvestigator();

        request.personnelId = personnelId;
        request.trialId= trialId;

        //Send request.
        const response: Promise<Dtos.CreateProjectInvestigatorResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setProjectInvestigator: (projectInvestigator: Dtos.ProjectInvestigator): Observable<Dtos.SetProjectInvestigatorResponse> => {

        let request: Dtos.SetProjectInvestigator = new Dtos.SetProjectInvestigator();

        request.projectInvestigator = projectInvestigator;

        // send request
        const response: Promise<Dtos.SetProjectInvestigatorResponse> = client.post(request);

        return Observable.from(response);
    },
    validateProjectInvestigator: (projectInvestigator: Dtos.ProjectInvestigator): Observable<Dtos.ValidateProjectInvestigatorResponse> => {

        let request: Dtos.ValidateProjectInvestigator = new Dtos.ValidateProjectInvestigator();

        request.projectInvestigator = projectInvestigator;

        // send request
        const response: Promise<Dtos.ValidateProjectInvestigatorResponse> = client.post(request);

        return Observable.from(response);
    }
}